import React from "react";
import { Card, Flex, Text, Button, Divider } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import SymptomsComponent from "../common/SymptomsComponent";
import { useSymptomsPutMutation } from "./api/useSymptomsMutation";
import { formatDate } from "../common/useDateFunctions";

export default function SymptomsCard({ data }) {
  const putSymptom = useSymptomsPutMutation();
  const navigate = useNavigate();
  return (
    <Card key={data.id} variation="elevated" maxWidth="350px">
      <Flex direction="row" style={{ marginBottom: "20px" }} justifyContent="space-between">
        <Button
          variation="primary"
          onClick={() => {
            navigate(`/user/quick-actions/overall-symptoms/${data.id}/edit`);
          }}
        >
          Edit
        </Button>
        <Button
          variation="primary"
          onClick={() => {
            const date = formatDate(new Date());
            const params = {
              id: data.id,
              symptom: data.symptomId,
              symptomStartDate: data.symptomStartDate,
              symptomEndDate: date,
              howStartExperience: data.howStartExperience,
              active: 0,
            };
            putSymptom.mutateAsync(params);
          }}
        >
          Mark as resolved
        </Button>
      </Flex>
      <Flex direction="column" alignItems="flex-start">
        <Flex direction="row" alignItems="center" justifyContent="center">
          <SymptomsComponent />
          <Text as="span" fontSize="12px">
            {data.symptom}
          </Text>
        </Flex>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          style={{ marginTop: "0px" }}
        ></Divider>
        <Flex direction="column" alignItems="center" justifyContent="center">
          <Text
            as="span"
            fontSize="12px"
            style={{ marginLeft: "12px", paddingBottom: "15px" }}
          >
            {data.howStartExperience}
          </Text>
        </Flex>
      </Flex>
      <Divider
        width="unset"
        height="1px"
        shrink="0"
        alignSelf="stretch"
        size="small"
        orientation="horizontal"
        style={{ marginTop: "0px" }}
      ></Divider>
      <Flex direction="column" alignItems="flex-start" gap={1}>
        <Text
          as="span"
          fontSize="12px"
          style={{ marginLeft: "12px", marginTop: "15px" }}
        >
          Symptoms Start Date: {data.symptomStartDate}
        </Text>
        <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
          Status: {data.active === 1 ? "Still Experiencing" : "Resolved"}
        </Text>
      </Flex>
    </Card>
  );
}
